import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FeatureService } from '../../core/feature.service';
import { FeatureHelper } from '../../core/static-classes/feature-helper';
import { STANDALONE_COMPONENT_IMPORTS } from '../standalone-component-imports';
import { SignalRStatusComponent } from '../signalr-status/signalr-status.component';

@Component({
    standalone: true,
    imports: [
        SignalRStatusComponent,
        ...STANDALONE_COMPONENT_IMPORTS,
    ],
    selector: 'pd-user-profile-modal',
    templateUrl: './user-profile-modal.component.html',
    styleUrls: ['./user-profile-modal.component.less']
})
export class UserProfileModalComponent {
    @Input()
    public environment: string;
    @Input()
    public featureFlags: PlantDesign.API.IToggleFeatureResponse[] = [];

    @Output()
    public closed = new EventEmitter<void>();

    constructor(private readonly featureService: FeatureService) {}

    public close(): void {
        this.closed.emit();
    }

    public isSignalREnabled(): boolean {
        return this.featureService.hasToggleFeature(FeatureHelper.flags.enableSignalRNotifications);
    }

    public copyFeatureFlagsToClipboard(): void {
        if (this.featureFlags.length === 0) {
            return;
        }
        const jsonString = JSON.stringify(this.featureFlags, null, 2);
        navigator.clipboard.writeText(jsonString);
    }

}
